// extracted by mini-css-extract-plugin
export default {"AppCustomers":"AppCustomers_AppCustomers__lxVHq","AppCustomers__wrap":"AppCustomers_AppCustomers__wrap__y8nBZ"};